var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100vh-100"},[_c('SystemCounterBar',{ref:"SystemCounterBar"}),_c('SystemCounterList',{ref:"SystemCounterList",attrs:{"gnbCounterTreeClickInfo":_vm.gnbCounterTreeClickInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }